import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';

import {
  runSimulations,
  getSimulations,
  updateSimulationStatus,
  calcReceived,
  simulationCleanup,
} from 'store/entities/simulations/simulations';

import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import ResultChart from '../simulations/result-overview/result-chart';
import '../simulations/result-overview/style.less';

/**
 * ResultChartGrid
 *
 * @param {Object} props
 * @param {{
 *   label: string,
 *   value: string,
 * }} props.selectedItem
 * @param {number} props.selectedDataEntity
 * @param {TRiskFilter} props.riskFilter
 * @param {{
 *   showPoints: boolean,
 *   backgroundColor: string,
 *   borderColor: string,
 * }} [props.scatterChartOptions]
 * @param {boolean} props.isReport
 *
 * @returns {JSX.Element}
 */
const ResultChartGrid = ({
  selectedItem,
  selectedDataEntity,
  getSimulations,
  simulations,
  simulationCleanup,
  riskFilter,
  scatterChartOptions,
  isReport = false,
}) => {
  const { project: projectId } = useParams();
  useEffect(() => {
    if (projectId && !isReport) {
      getSimulations(projectId);
    }

    return () => simulationCleanup();
  }, [projectId]);

  return (
    <ResultChart
      selectedItem={selectedItem}
      selectedDataEntity={selectedDataEntity}
      simulationsResult={simulations?.simulationsResult}
      controlsPortalId={'controls'}
      riskFilter={riskFilter}
      scatterChartOptions={scatterChartOptions}
    />
  );
};

const mapStateToProps = ({ entities }) => {
  const { simulations } = entities;

  return {
    simulations,
  };
};

const mapDispatchToProps = {
  runSimulations,
  getSimulations,
  updateSimulationStatus,
  calcReceived,
  simulationCleanup,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(ResultChartGrid));

export { Container as ResultChartGrid };
